export class Video {}
